"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListItem = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _ListContext = require("./_ListContext");
var _ListItem = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ListItem.css") : void 0);
var _excluded = ["children", "className", "divider", "isGroupHeader"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var CSS_BLOCK = 'sapcnqr-list-item';
var ListItem = exports.ListItem = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _context;
  var children = props.children,
    className = props.className,
    divider = props.divider,
    isGroupHeader = props.isGroupHeader,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_ListItem.default);
  var listContextValue = (0, _react.useContext)(_ListContext.ListContext);
  var _ref = listContextValue || {},
    bordered = _ref.bordered,
    isUsingGroups = _ref.isUsingGroups,
    size = _ref.size;
  var classes = classnames(CSS_BLOCK, className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--grouped"), isUsingGroups && !isGroupHeader), "".concat(CSS_BLOCK, "--bordered"), bordered), (0, _concat.default)(_context = "".concat(CSS_BLOCK, "--")).call(_context, size), !!size));
  if (divider) {
    return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({}, otherProps, {
      className: classnames(className, CSS_BLOCK, "".concat(CSS_BLOCK, "__divider")),
      ref: ref,
      role: "separator",
      "aria-hidden": true
    }));
  }
  return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({}, otherProps, {
    className: classes,
    ref: ref
  }), children);
});
ListItem.displayName = 'List.Item';
ListItem.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  /** Set to `true` if list item should be rendered as a divider. */
  divider: _propTypes.default.bool,
  /** @ignore - set by List.Group */
  isGroupHeader: _propTypes.default.bool
};
var _default = exports.default = ListItem;